
import React from 'react';
import { WaitlistWidget } from './WaitlistWidget';
import { Button } from '@/components/ui/button';

const QuestionsCTA = () => {
  return (
    <section className="bg-white py-20" id="questions-section">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-4xl font-bold mb-6">Still Have Questions?</h2>
        <p className="text-xl text-gray-600 mb-10 max-w-2xl mx-auto">
          We're here to help! Reach out to our team and we'll get back to you as soon as possible.
        </p>
        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <a href="http://savyi.co/i/contact-us">
            <Button 
              className="rounded-full px-6 py-3 text-white font-medium bg-[#2432ff] hover:bg-[#1c29e8] transition-colors duration-300 shadow-lg"
              aria-label="Contact support team"
            >
              Contact Support
            </Button>
          </a>
          <WaitlistWidget variant="hero" buttonText="Get Early Access" />
        </div>
      </div>
    </section>
  );
};

export default QuestionsCTA;
